import { styled } from "@material-ui/core";

export const TTTElementContainer = styled("div")(({ theme }) => ({
  border: `1px solid ${theme.palette.grey[300]}`,
  borderRadius: theme.spacing(1),
  padding: theme.spacing(2),
  cursor: "pointer",
  width: "250px",

  [`${theme.breakpoints.down("sm")}`]: {
    width: "350px",
  },

  "&:hover": {
    "& *.cls-1": {
      fill: `${theme.palette.primary.dark} !important`,
    },
    "& *.ttt-title": {
      textDecoration: "underline",
    },
  },
}));

export const TTTElementTitleContainer = styled("div")({
  justifyContent: "center",
  alignItems: "center",
  display: "flex",
  width: "100%",
});

export const TTTElementImageContainer = styled("div")(({ theme }) => ({
  color: theme.palette.common.white,
  marginBottom: theme.spacing(2),
  justifyContent: "center",
  position: "relative",
  alignItems: "center",
  display: "flex",
  width: "100%",

  "& > img": {
    width: "100%",
  },
}));

export const TTTElementIconContainer = styled("div")(({ theme }) => ({
  justifyContent: "center",
  position: "absolute",
  borderRadius: "2rem",
  alignItems: "center",
  height: "4rem",
  width: "4rem",
  opacity: 0.9,

  "& *.cls-1": {
    fill: `${theme.palette.primary.main} !important`,
    transition: "0.2s",
  },
  "& *.cls-2": {
    fill: `${theme.palette.common.white} !important`,
  },
}));



// WEBPACK FOOTER //
// ./resources/assets/js/app/TeachersToolkit/TeachersToolkitTraining/components/TTTElement/TTTElement.styled.js